import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  DxDataGridComponent,
  DxDataGridModule,
  DxTextBoxModule,
  DxButtonModule,
} from "devextreme-angular";
import { SparkHistoryService } from "./spark-history.service";
import { AppGlobals } from "../../../../../../../app.globals";
import { Subscription } from "rxjs";
import { GpdButtonComponent } from "../../../../../../../components/gpd-button/gpd-button.component";
import { ConfigService } from "src/app/services/config.service";

@Component({
    selector: "app-spark-history-overlay",
    imports: [
        CommonModule,
        DxDataGridModule,
        DxTextBoxModule,
        DxButtonModule,
        GpdButtonComponent,
    ],
    templateUrl: "./spark-history-overlay.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./spark-history-overlay.component.css"]
})
export class SparkHistoryOverlayComponent implements OnInit, OnDestroy {
  @ViewChild("historyGrid", { static: false }) historyGrid: DxDataGridComponent;

  isVisible = false;
  currentSparkId: number | null = null;
  logData: any[] = [];
  searchTerm = "";
  isLoading = false;

  private subscriptions = new Subscription();

  constructor(
    public sparkHistoryService: SparkHistoryService,
    public appGlobals: AppGlobals,
    public configService: ConfigService
  ) {}

  ngOnInit(): void {
    // Subscribe to overlay visibility
    this.subscriptions.add(
      this.sparkHistoryService.isOverlayVisible$.subscribe((isVisible) => {
        this.isVisible = isVisible;
        if (isVisible && this.currentSparkId) {
          this.loadSparkHistory();
        }
      })
    );

    // Subscribe to spark ID changes
    this.subscriptions.add(
      this.sparkHistoryService.currentSparkId$.subscribe((sparkId) => {
        this.currentSparkId = sparkId;
        if (sparkId && this.isVisible) {
          this.loadSparkHistory();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  async loadSparkHistory(): Promise<void> {
    if (!this.currentSparkId) return;

    this.isLoading = true;
    try {
      const result = await this.sparkHistoryService.getSparkLogs(
        this.currentSparkId,
        this.searchTerm || undefined
      );

      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
        this.logData = [];
      } else {
        this.logData = result.logDetails || [];
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage("Failed to load spark history");
      this.logData = [];
    } finally {
      this.isLoading = false;
    }
  }

  onSearchValueChanged(event: any): void {
    this.searchTerm = event.value || "";
    this.loadSparkHistory();
  }

  onCloseClick(): void {
    this.sparkHistoryService.closeSparkHistory();
  }

  formatDate(date: any): string {
    if (!date) return "";
    return new Date(date).toLocaleDateString("de-DE");
  }
}
